var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C13.9783 19 16.2172 18.9996 17.6084 17.6084C18.9996 16.2172 19 13.9783 19 9.5C19 5.02166 18.9996 2.78284 17.6084 1.3916C16.2172 0.000358582 13.9783 0 9.5 0C5.02166 0 2.78284 0.000358582 1.3916 1.3916C0.00035882 2.78284 0 5.02166 0 9.5C0 13.9783 0.00035882 16.2172 1.3916 17.6084C2.78284 18.9996 5.02166 19 9.5 19ZM9.5 14.25C9.08579 14.25 8.75 13.9142 8.75 13.5L8.75 10.25L5.5 10.25C5.08579 10.25 4.75 9.91421 4.75 9.5C4.75 9.08579 5.08579 8.75 5.5 8.75L8.75 8.75V5.5C8.75 5.08579 9.08579 4.75 9.5 4.75C9.91421 4.75 10.25 5.08579 10.25 5.5V8.75H13.5C13.9142 8.75 14.25 9.08579 14.25 9.5C14.25 9.91421 13.9142 10.25 13.5 10.25H10.25L10.25 13.5C10.25 13.9142 9.91421 14.25 9.5 14.25Z",
    fill: "#0E2F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.6a089689478c20941ed3c8932d9a510c.svg";
export { ForwardRef as ReactComponent };